/**
 * Centralized Socket Event Constants
 * Mapping active socket event names to prevent hardcoded strings.
 */
export const Events = Object.freeze({
  // Built-in Socket.IO Lifecycle Events
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',
  RECONNECT: 'reconnect',

  // Real-time Domain Inbound Events
  MEMBER_LINK_NOTIFICATION: 'memberLinkNotification',

  // Outbound / Client-Emitted Events
  JOIN_ROOM: 'join_room',
});

export default Events;
